<template>
    <div component="Doc">
        <div class="content">
            <div v-bar class="vb">
                <div>
                    <div class="holder">
                        <div block="menu">
                            <router-link v-for="link in links" :key="link.link" :to="link.link">{{
                                link.text
                            }}</router-link>
                        </div>

                        <transition name="zoomIn">
                            <router-view view="detail"></router-view>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Doc',

    data() {
        return {
            links: [
                {
                    link: '/doc/buttons',
                    text: 'buttons',
                },
                {
                    link: '/doc/forms',
                    text: 'forms',
                },
                {
                    link: '/doc/typography',
                    text: 'typography',
                },
                {
                    link: '/doc/color',
                    text: 'color',
                },
                {
                    link: '/doc/container',
                    text: 'container',
                },
            ],
        };
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='Doc'] {
    height: calc(100% - 60px);
    width: 100%;

    .content {
        max-width: 1200px !important;
        padding: 20px 10px;
    }

    [block='menu'] {
        .flex-center;
        padding: 5px 20px;
        background-color: @white;
        position: fixed;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        box-shadow: 0 5px 30px 1px rgba(0, 0, 0, 0.3);
        .radius-b;
        z-index: 6;

        a {
            display: inline-flex;
            padding: 5px 10px;
            font-size: 13px;
            font-weight: 900;
            transition: 0.3s;
            color: @black;

            &:hover {
                color: @dark;
            }

            &.router-link-active {
                color: @accent;
            }
        }
    }

    section {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        margin-top: -1px;

        &:last-child {
            border-bottom-width: 1px;
        }

        .demo {
            display: flex;
            flex-direction: column-reverse;
            align-items: center;
            padding-top: 10px;
            min-width: 150px;
        }

        .desc {
            font-size: 13px;
            padding: 5px 10px;
            margin: 10px;
            .border;
            .radius;
        }

        &.header {
            flex-direction: column;
            align-items: center;
            border-width: 0px;
            padding: 10px;

            .desc {
                font-size: 18px;
            }

            &:before {
                content: none;
            }
        }

        &.remote {
        }

        &.body {
            border: 1px solid @grey_lt;
        }

        .name {
            width: 120px;
            background-color: fade(@grey_ltr, 70%);
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }

        .content {
            width: ~'calc(100% - 150px)';
            display: flex;
            flex-wrap: wrap;
            padding: 10px 20px 10px;
        }
    }

    [component='NavButton'] {
        &[radius='circle'] {
        }
    }

    [component='Mp3Player'] {
        margin: 10px 20px 20px;
    }

    h1 {
        text-align: center;
        margin-top: 40px;
    }

    h2 {
        padding: 0px 15px;

        span {
            font-size: 12px;
            font-weight: 900;
        }
    }
}
</style>
